var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6418_2721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6418_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81453 13.9566C5.1352 13.6611 4.54409 13.2618 4.0412 12.7588C3.5382 12.2559 3.13892 11.6648 2.84337 10.9855C2.54781 10.3062 2.40003 9.57774 2.40003 8.79996C2.40003 8.02218 2.54781 7.29368 2.84337 6.61446C3.13892 5.93513 3.5382 5.34401 4.0412 4.84113C4.54409 4.33813 5.1352 3.93885 5.81453 3.64329C6.49375 3.34774 7.22226 3.19996 8.00003 3.19996C8.77781 3.19996 9.50631 3.34774 10.1855 3.64329C10.8649 3.93885 11.456 4.33813 11.9589 4.84113C12.4619 5.34401 12.8611 5.93513 13.1567 6.61446C13.4523 7.29368 13.6 8.02218 13.6 8.79996C13.6 9.57774 13.4523 10.3062 13.1567 10.9855C12.8611 11.6648 12.4619 12.2559 11.9589 12.7588C11.456 13.2618 10.8649 13.6611 10.1855 13.9566C9.50631 14.2522 8.77781 14.4 8.00003 14.4C7.22226 14.4 6.49375 14.2522 5.81453 13.9566ZM9.6667 11.0666L10.5167 10.2166L8.60003 8.29996V5.59996H7.40003V8.79996L9.6667 11.0666ZM3.95003 1.91663L4.80003 2.76663L1.9667 5.59996L1.1167 4.74996L3.95003 1.91663ZM12.05 1.91663L14.8834 4.74996L14.0334 5.59996L11.2 2.76663L12.05 1.91663Z",
    fill: "#B3531B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.c90acf8f4b7bf3b4d3935539c65a97fa.svg";
export { ForwardRef as ReactComponent };